var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page"},[_c('HeroSection'),_c('PlatformSection'),_c('AiModelSection'),_c('CloudSection'),_c('RobotSection'),_c('CertificationSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }